import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastService } from "../../services/forecastService";

(function (module) {
    "use strict";

    module.component('forecastMathFunction', {
        template: require('./forecastMathFunctionComponent.html'),
        bindings: {
            parameters: "<",
            additionalForecast: "<",
            additionalHistoricaldata: '<',
            enter: "=",
            status: "=",
            statisticalForecast: "=",
            isSku: "<",
            isEditable: "<"
        },
        controller: ['$scope', '$rootScope', 'dtpChartService', 'mathFunctionService', ForecastService.componentName, angularServicesNames.$translate, 'debounce',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $rootScope: ng.IRootScopeService,
                dtpChartService: $TSFixMe,
                mathFunctionService: $TSFixMe,
                forecastService: ForecastService,
                $translate: ng.translate.ITranslateService,
                debounce: $TSFixMe
            ) {
                var $ctrl = this;

                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();
                function resetChartTranslations() {
                    $translate(['CHART_SERIES.FORECAST_BASE', 'CHART_SERIES.DATA_AFTER_SMOOTHING', 'FORECAST.CHART.FORECAST_MARKET']).then(function (translations: $TSFixMe) {
                        $ctrl.datasetOverride = [
                            {
                                label: translations["CHART_SERIES.DATA_AFTER_SMOOTHING"],
                                yAxisID: "y-value",
                            },
                            {
                                label: translations["CHART_SERIES.FORECAST_BASE"],
                                yAxisID: "y-value",
                            },
                            {
                                label: translations["FORECAST.CHART.FORECAST_MARKET"],
                                yAxisID: "y-value",
                                borderColor: "rgba(235,154,110, 1)",
                                backgroundColor: "rgba(235,154,110, 1)",
                                hidden: true
                            }
                        ];
                    });
                }


                $ctrl.computeRegression = function () {
                    $ctrl.serverOperation = mathFunctionService.calculateRegression($ctrl.statisticalForecast, $ctrl.parameters, $ctrl.statisticalForecast.regression).then(function () {
                        $ctrl.itemsToDisplay = [
                            $ctrl.statisticalForecast.dataAfterSmoothing,
                            $ctrl.statisticalForecast.regressionWholePeriod,
                            getStatisticalForecast()
                        ];
                    });
                };

                $ctrl.isMachineLearningReady = () =>
                    
                    _.some($ctrl.statisticalForecast.machineLearningData, (ml: $TSFixMe) => ml.calculationIsReady && ml.monthNumberForAverage == $ctrl.statisticalForecast.period);


                $ctrl.isMachineLearningAvaiable = () => angular.isArray($ctrl.statisticalForecast.machineLearningData);

                
                $ctrl.hasMissingMlModels = () => _.some($ctrl.statisticalForecast.machineLearningData, (ml: $TSFixMe) => !ml.calculationIsReady);

                $ctrl.refreshMlModels = () => $rootScope.$broadcast('refresh-ml-models');

                $scope.$watch('$ctrl.parameters.forecastMethod.methodId', (methodId: $TSFixMe) => {
                    if (methodId) {
                        forecastService.isMlModelEnabled($ctrl.parameters.forecastMethod.methodId).then((isMlModelEnabled: $TSFixMe) => $ctrl.isMlModelEnabled = isMlModelEnabled);
                    }
                });

                $scope.$watchGroup(['$ctrl.statisticalForecast.dataAfterSmoothing', '$ctrl.statisticalForecast.regressionWholePeriod'], debounce(function () {

                    if (angular.isUndefinedOrNull($ctrl.statisticalForecast)

                        || angular.isUndefinedOrNull($ctrl.statisticalForecast.dataAfterSmoothing)) {
                        return;
                    }
                    $ctrl.itemsToDisplay = [$ctrl.statisticalForecast.dataAfterSmoothing];

                    if (!angular.isUndefinedOrNull($ctrl.statisticalForecast.regressionWholePeriod)) {
                        $ctrl.itemsToDisplay.push($ctrl.statisticalForecast.regressionWholePeriod);

                        if (!angular.isUndefinedOrNull($ctrl.isSku)) {
                            $ctrl.itemsToDisplay.push($ctrl.additionalHistoricaldata.concat($ctrl.additionalForecast));
                        }
                    }
                }), 500);

                $ctrl.$onInit = function () {
                    $ctrl.labels = dtpChartService.preparePeriodsAndLabels($ctrl.parameters.historicalDataStart, $ctrl.parameters.forecastEndDate).periods;
                    $ctrl.options = {
                        scales: {
                            yAxes: [
                                {
                                    id: 'y-value',
                                    display: true,
                                    position: 'left',
                                    ticks: { suggestedMin: 0 }
                                }

                            ]
                        }
                    };

                    if (!angular.isUndefinedOrNull($ctrl.isSku)) {
                        $ctrl.options.scales.yAxes.push({
                            id: 'y-value',
                            display: true,
                            ticks: { suggestedMin: 0 }
                        });
                    }
                }

                function getStatisticalForecast() {
                    var historyLength = dtpChartService.getPeriodLenghtInMonths($ctrl.parameters.historicalDataStart, $ctrl.parameters.historicalDataEnd);
                    
                    return _.times(historyLength, _.constant(null)).concat($ctrl.statisticalForecast.statisticalForecast);
                }
            }]
    })

})(angular.module('topline.modules'));
